import './phone-conference-actions.ajscss';

import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentTitleService } from '@agent/agent-interface/agent-title.service';
import { ITransferDeprecatedService } from '@agent/core/contact/transfer/transfer-deprecated.service';
import { IConferenceDeprecatedService } from '@agent/core/phone/conference/conference-deprecated.service';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions } from 'angular';
import { filter, switchMap, take } from 'rxjs';

import {
  ConferenceFacade,
  DisplayDeprecatedComponent,
  filterOfArr,
  firstOfArr,
  isNotNullOrUndefined,
  ParticipantFacade,
} from '@contact/upgrade';

import templateUrl from './phone-conference-actions.template.html';
import { PhoneTransferActionsService } from './phone-transfer-actions.service';

const MODULE_NAME = 'contactPhoneConferenceActions';

export class PhoneConferenceActionsCtrl extends DisplayDeprecatedComponent implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;
  guestId: string;
  contactId: string;

  canValidateTransfer = true;
  contactParked = true;
  guestParked = false;

  constructor(
    protected readonly conferenceDeprecatedService: IConferenceDeprecatedService,
    protected readonly transferDeprecatedService: ITransferDeprecatedService,
    protected readonly agentTitleService: AgentTitleService,
    protected readonly phoneTransferActionsService: PhoneTransferActionsService,
    protected readonly conferenceFacade: ConferenceFacade,
    protected readonly participantFacade: ParticipantFacade,
    protected readonly router: AgentDesktopRouter
  ) {
    super();
  }

  $onInit(): void {
    const contact$ = this.participantFacade.getAllByConferenceId(this.responseId).pipe(
      filterOfArr(({ kind }) => kind.customer),
      firstOfArr(),
      isNotNullOrUndefined()
    );
    const contactParked$ = contact$.pipe(switchMap(({ id }) => this.participantFacade.isParked(id)));
    const guestParked$ = this.participantFacade.isParked(this.guestId);

    contact$.pipe(take(1), ng1Destroy(this)).subscribe(({ id }) => (this.contactId = id));
    contactParked$.pipe(ng1Destroy(this)).subscribe(parked => (this.contactParked = parked));
    guestParked$.pipe(ng1Destroy(this)).subscribe(parked => (this.guestParked = parked));

    // if guest leave redirect to main screen
    this.conferenceDeprecatedService
      .guestState$()
      .pipe(
        filter(guest => guest.removed),
        ng1Destroy(this)
      )
      .subscribe(() => this.router.navigateFromLastChild(['../..']));
  }

  validateTransfer(): void {
    this.canValidateTransfer = false;
    this.conferenceFacade
      .forwardTo(this.responseId, this.guestId)
      .afterEvent$.pipe(ng1Destroy(this))
      .subscribe({
        error: () => (this.canValidateTransfer = true),
      });
  }

  cancelTransfer(): void {
    this.canValidateTransfer = false;
    this.conferenceFacade
      .cancel(this.responseId)
      .afterEvent$.pipe(ng1Destroy(this))
      .subscribe({
        error: () => (this.canValidateTransfer = true),
        complete: () => this.router.navigateFromLastChild(['../..']),
      });
  }

  parkContact(): void {
    if (!this.guestId) {
      return;
    }
    this.participantFacade
      .speakWith(this.responseId, [this.guestId])
      .afterEvent$.pipe(ng1Destroy(this))
      .subscribe({
        complete: () => this.agentTitleService.refresh(),
      });
  }

  parkGuest(): void {
    if (!this.contactId) {
      return;
    }
    this.participantFacade
      .speakWith(this.responseId, [this.contactId])
      .afterEvent$.pipe(ng1Destroy(this))
      .subscribe({
        complete: () => this.agentTitleService.refresh(),
      });
  }

  conferencing(): void {
    this.participantFacade
      .speakWithAll(this.responseId)
      .afterEvent$.pipe(ng1Destroy(this))
      .subscribe({
        complete: () => this.agentTitleService.refresh(),
      });
  }
}

export class PhoneConferenceActions implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
    guestId: '<',
  };
  controller = [
    'conferenceDeprecatedService',
    'transferDeprecatedService',
    'agentTitleService',
    'phoneTransferActionsService',
    'conferenceFacade',
    'participantFacade',
    'agentDesktopRouter',
    PhoneConferenceActionsCtrl,
  ];
}

export default MODULE_NAME;
